module.exports = __webpack_public_path__ + "img/home-gray.ce804791.svg";